module.exports = __webpack_public_path__ + "img/product-img_1.9d56aba0.png";